import MDEditor from "@uiw/react-md-editor";
import {MarkdownPreviewProps} from "@uiw/react-markdown-preview";
import React from "react";

export default function MarkdownPreview(props: MarkdownPreviewProps) {
    return <MDEditor.Markdown {...props} />;
}